import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createCategories, getAllCategories } from "../actions/categories";
import { paginationDataToShow } from "../actions/generalActions";
// import ActiveFormModal from "../components/ActiveFormModal";
// import AdminGeneralEditModal from "../components/AdminGeneralEditModal";
// import AdminCateEditModal from "../components/AdminCateEditModal";
import AdminCateListRow from "../components/AdminCateListRow";
import defaultPic from "../assets/img/dummy.jpeg";
import AWS from "aws-sdk";
import axios from "axios";
import {
  BUCKET_ACCESS_KEY_ID,
  BUCKET_BASE_URL,
  BUCKET_ENDPOINT,
  BUCKET_NAME,
  BUCKET_REGION,
  BUCKET_SECRET_KEY,
  SERVERADDRESS,
} from "../../src/constants";

const S3_BUCKET = BUCKET_NAME;
// const REGION ='YOUR_DESIRED_REGION_HERE';

AWS.config.update({
  accessKeyId: BUCKET_ACCESS_KEY_ID,
  secretAccessKey: BUCKET_SECRET_KEY,
});
const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: BUCKET_REGION,
  endpoint: BUCKET_ENDPOINT,
  // region: REGION,
});

const AdminCategories = () => {
  const categories = useSelector((state) => state.categories);
  const store = useSelector((state) => state.store);
  const [progress, setProgress] = useState(0);
  const [awsURL, setAwsURL] = useState(null);
  const [selectedImage, setSelectedImage] = useState(defaultPic);
  const [profileData, setProfileData] = useState({});

  const navigate = useNavigate();
  const [values, setValues] = useState({
    name: "",
    status: "",
    profilePic: "",
  });
  // console.log(values, "values");
  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };
  const dispatch = useDispatch();

  const cb = () => {
    dispatch(getAllCategories());
    setValues({
      name: "",
      status: "",
    });
  };
  const categoriesData = {
    name: values.name,
    profilePic: values.profilePic,
    status: values.status ? values.status : true,
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc"); //asc, desc
  const [searchTerm, setSearchTerm] = useState("");
  const [limit, setLimit] = useState(25); // Set your default limit here

  // Function to handle pagination, sorting, and searching
  const handlePagination = (page, field, order, search, newLimit) => {
    let newPage;
    if (page < 1) {
      newPage = 1;
    } else if (page > paginatedData.totalPages) {
      newPage = paginatedData.totalPages;
    } else {
      newPage = page;
    }
    setCurrentPage(newPage);
    setSortField(field);
    setSortOrder(order);
    setSearchTerm(search);
    setLimit(newLimit);
  };

  const fullData = categories?.categories;
  // Use the pagination function to get the data for the current page
  const paginatedData = paginationDataToShow(
    limit,
    currentPage,
    fullData,
    sortField,
    sortOrder,
    searchTerm
  );
  // Function to handle sorting icon click
  const handleSortClick = (field, order) => {
    // Call handlePagination with sorting parameters
    handlePagination(currentPage, field, order, searchTerm, limit);
  };
  // Function to determine the color based on the current sorting order
  const getArrowColor = (field, direction) => {
    return sortField === field && sortOrder === direction
      ? "#000000"
      : "#A0A0A0";
  };

  const handleChangePic = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Display the selected image immediately
    const tempUrl = URL.createObjectURL(file);
    setSelectedImage(tempUrl);

    console.log("Uploading file...");
    // console.log("cccccccccccccccc");

    const today = new Date();
    const date = today.getTime();
    const params = {
      Bucket: S3_BUCKET,
      //   Key:
      //     "data/" +
      //     "SuperAdminData" +
      //     "/ProfilePic/" +
      //     date +
      //     "/" +
      //     event.target.files[0].name,
      //   Body: event.target.files[0],
      Key: `data/SuperAdminData/ProfilePic/${date}/${file.name}`,
      Body: file,
      ACL: "public-read",
    };
    var upload = myBucket
      .upload(params)
      .on("httpUploadProgress", (evt) => {
        setProgress(Math.round((evt.loaded / evt.total) * 100));
      })
      .promise();
    let url;
    await upload.then(function (data, err) {
      try {
        url = BUCKET_BASE_URL + data.Key;
        setAwsURL(url);
        console.log(url, "url");
      } catch (error) {
        // console.log(error, err, "ee");
      }
      console.log(upload, "upload");
    });

    const { data } = await axios.post(
      `${SERVERADDRESS}/v1/fileupload/profilePicUpload`,
      {
        // url: url,
        // file: event.target.files[0].name,
        // type: event.target.files[0].type,
        url: url,
        file: file.name,
        type: file.type,
        // userId: auth.user.id,
        // companyId: auth.user.companyId.id,
      }
    );
    // setSelectedImage(url);
    setValues({
      ...values,
      ["profilePic"]: data.id,
    });
    // dispatch(createUser({ userId: auth.user.id, profilePic: data.id }));
    console.log(data, "data");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // console.log("first");
    for (let key of Object.keys(categoriesData)) {
      if (categoriesData[key] === "") {
        delete categoriesData[key];
      }
    }
    dispatch(createCategories(categoriesData, cb));
    setValues({
      profilePic: "",
      name: "",
      status: "",
    });
  };
  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-xl-4 col-sm-4 col-12">
                <div className="card rounded-1">
                  <div className="card-header py-3">
                    <h5 className="card-title">Category Information</h5>
                  </div>
                  <div className="card-body p-3">
                    <form onSubmit={handleSubmit} className="row">
                      <div className="col-md-12">
                        <div className="text-center mb-3">
                          <label
                            className="avatar avatar-xxl profile-cover-avatar m-0 m-auto"
                            // htmlFor="avatar_upload"
                          >
                            {selectedImage && (
                              <img
                                className="rounded border shadow-sm"
                                src={selectedImage}
                                alt="Picture"
                              />
                            )}
                            <input
                              type="file"
                              id="avatar_upload"
                              className="d-none"
                              accept=".jpg, .jpeg, .png"
                              onChange={handleChangePic}
                            />
                            <span
                              className="avatar-edit"
                              type="file"
                              accept=".jpg, .jpeg, .png"
                              onChange={handleChangePic}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-edit-2 avatar-uploader-icon shadow-soft"
                              >
                                <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                              </svg>
                            </span>
                          </label>
                          <p
                            className="fw-light text-info"
                            style={{ fontSize: "12px" }}
                          >
                            .jpg, .jpeg, .png, .bmp recommended size (512 X 512)
                            pixels
                          </p>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="mb-3">
                          <label htmlFor="Categoryname" className="form-label">
                            Category Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="Categoryname"
                            placeholder="Category Name"
                            value={values.name}
                            onChange={handleChange("name")}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="mb-3">
                          <label
                            htmlFor="CategoryStatus"
                            className="form-label"
                          >
                            Category Status
                          </label>
                          <select
                            className="form-select"
                            id="CategoryStatus"
                            value={values.status}
                            onChange={handleChange("status")}
                          >
                            <option value="0" disabled>
                              Select Status
                            </option>
                            <option value={true}>Active</option>
                            <option value={false}>Deactive</option>
                          </select>
                        </div>
                      </div>

                      <div className="col-12">
                        <button type="submit" className="btn btn-success">
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-xl-8 col-sm-8 col-12">
                <div className="card rounded-1 card-table">
                  <div className="card-header py-3">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title">All Categories</h5>
                      </div>
                      <div className="col-auto">
                        <div className="d-flex gap-3">
                          <button className="btn btn-success">
                            Export as CSV
                          </button>
                          <button className="btn btn-warning">
                            Bulk CSV Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row mx-2 my-2">
                      <div className="col">
                        <form action="">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search Category"
                            />
                            <button className="btn btn-primary" type="submit">
                              Search
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div
                      className="table-responsive"
                      style={{ scrollbarWidth: "thin" }}
                    >
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Id</th>
                            <th>Cover</th>
                            <th>Category Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {categories &&
                            categories?.categories &&
                            categories?.categories?.length > 0 &&
                            // categories?.categories?.map((current, i) => {
                            paginatedData?.results.map((current, i) => {
                              if (current.delete === false) {
                                return (
                                  <AdminCateListRow
                                    current={current}
                                    i={i}
                                    key={i}
                                    // handleModal={handleModal}
                                  />
                                );
                              }
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                      <p className="text-dark">
                        Showing{" "}
                        {1 +
                          paginatedData?.limit *
                            (paginatedData?.currentPageNumber - 1)}{" "}
                        to{" "}
                        {paginatedData?.displayingResults +
                          paginatedData?.limit *
                            (paginatedData?.currentPageNumber - 1)}{" "}
                        of {paginatedData?.totalResults} entries
                      </p>

                      <nav aria-label="...">
                        <ul className="pagination">
                          {/* Previous Button */}
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <NavLink
                              className="page-link"
                              href="#"
                              tabIndex="-1"
                              aria-label="Previous"
                              onClick={(e) => {
                                e.preventDefault();
                                if (currentPage > 1) {
                                  handlePagination(
                                    currentPage - 1,
                                    sortField,
                                    sortOrder,
                                    searchTerm,
                                    limit
                                  );
                                }
                              }}
                            >
                              Previous
                            </NavLink>
                          </li>

                          {/* Dynamic Pagination Buttons */}
                          {paginatedData?.paginationArr?.length > 0 &&
                            Array.from(
                              {
                                length:
                                  paginatedData.endPage -
                                  paginatedData.startPage +
                                  1,
                              },
                              (_, i) => {
                                const current = paginatedData?.startPage + i;
                                return paginatedData?.currentPageNumber ===
                                  current ? (
                                  <li className="page-item active" key={i}>
                                    <a className="page-link" href="#">
                                      {current}{" "}
                                      <span className="sr-only">(current)</span>
                                    </a>
                                  </li>
                                ) : (
                                  <li className="page-item" key={i}>
                                    <NavLink
                                      className="page-link"
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handlePagination(
                                          parseInt(current),
                                          sortField,
                                          sortOrder,
                                          searchTerm,
                                          limit
                                        );
                                      }}
                                    >
                                      {current}
                                    </NavLink>
                                  </li>
                                );
                              }
                            )}

                          {/* Next Button */}
                          <li
                            className={`page-item ${
                              currentPage === paginatedData?.totalPages
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <a
                              className="page-link"
                              href="#"
                              aria-label="Next"
                              onClick={(e) => {
                                e.preventDefault();
                                if (currentPage < paginatedData?.totalPages) {
                                  handlePagination(
                                    currentPage + 1,
                                    sortField,
                                    sortOrder,
                                    searchTerm,
                                    limit
                                  );
                                }
                              }}
                            >
                              Next
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminCategories;
